/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * TAF Delivery API
 * OpenAPI spec version: 1.0
 */

export type AccommodationLandingPageContentResponseModelContentType = typeof AccommodationLandingPageContentResponseModelContentType[keyof typeof AccommodationLandingPageContentResponseModelContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccommodationLandingPageContentResponseModelContentType = {
  accommodationLandingPage: 'accommodationLandingPage',
} as const;
